import type { WallOpening } from '../framing/generateFramedWall';

/** Clear full-height wall runs only. No sheathing, anchorage or capacity is assumed.
 * Right wall is panorama; opening coordinates use each engine wall's local origin.
 */
export function panoramaBracingSpace(dimensions: { width: number; length: number }, openings: WallOpening[]) {
  return (['left', 'front', 'back'] as const).map(wall => {
    const lengthMm = Math.round((wall === 'left' ? dimensions.length : dimensions.width) * 1000);
    if (!Number.isFinite(lengthMm) || lengthMm <= 0) throw new Error('Invalid wall length');
    const cuts = openings.filter(o => o.wall === wall).map(o => {
      if (!Number.isFinite(o.xMm) || !Number.isFinite(o.widthMm) || o.widthMm <= 0) throw new Error('Invalid opening span');
      return { startMm: Math.max(0, o.xMm), endMm: Math.min(lengthMm, o.xMm + o.widthMm) };
    }).filter(o => o.endMm > o.startMm).sort((a,b) => a.startMm-b.startMm);
    const clearRuns: Array<{ startMm: number; endMm: number }> = [];
    let cursor = 0;
    for (const opening of cuts) {
      if (opening.startMm > cursor) clearRuns.push({ startMm: cursor, endMm: opening.startMm });
      cursor = Math.max(cursor, opening.endMm);
    }
    if (cursor < lengthMm) clearRuns.push({ startMm: cursor, endMm: lengthMm });
    return { wall, clearRuns, longestClearRunMm: Math.max(0, ...clearRuns.map(r => r.endMm-r.startMm)) };
  });
}
